import React, { useEffect, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Context } from "../Context";
import { LOGOUT, fetchData } from "..//Service";
import LanguageSelect from "../LanguageSelect";
import Cookies from "universal-cookie";
import i18next from "i18next";

const Header = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const cookies = new Cookies();

  const [context, setContext] = useContext(Context);
  const [isLoggedin, setIsLoggedin] = useState(false);
  const user = useState(cookies.get("user"));

  useEffect(() => {
    if (cookies.get("user") && cookies.get("user") !== undefined) {
      setContext((prevState) => ({
        ...prevState,
        user: cookies.get("user"),
      }));
    }
    if (isLoggedin || !cookies.get("user")) {
      cookies.remove("panda-token", { path: "/" });
      cookies.remove("user", { path: "/" });
      cookies.remove("user", { path: "/admin" });
      localStorage.clear();
      setContext(null);
      navigate("../");
    }
  }, [isLoggedin]);

  const logout = () => {
    if (user.deviceId) {
      const formdata = {
        device_info: {
          device_id: user.deviceId,
        },
      };
      fetchData(LOGOUT, "POST", formdata, true, true, (res) => {
        if (res.status) {
          setIsLoggedin(true);
        }
      });
    } else {
      setIsLoggedin(true);
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg border-green">
        <div className="container">
          <Link className="navbar-brand p-0" to="/">
            <img src="/images/logo.png" className="logo en-img" alt="..." />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            {context && context.key && context.key.auth_key ? (
              <>
                <ul className="navbar-nav en-ms-auto ar-me-auto mb-lg-0">
                  <li className="nav-item me-5">
                    <Link
                      to={`${
                        context &&
                        context.request_profile_confirmation &&
                        !context.is_loyalty_customer
                          ? "/admin/registration"
                          : "/admin/dashboard"
                      }`}
                      className="nav-link"
                    >
                      {t("Menu.home")}
                    </Link>
                  </li>
                  <li className="nav-item me-5">
                    <Link to="/admin/registration" className="nav-link">
                      <i
                        className="fa fa-user  d-md-me-2  d-sm-m-0 "
                        aria-hidden="true"
                      ></i>{" "}
                      {t("Menu.profile")}
                    </Link>
                  </li>
                  <li className="nav-item me-5">
                    <Link to="#" onClick={() => logout()} className="nav-link">
                      {t("Menu.logout")}
                    </Link>
                  </li>
                  <li className="nav-item p-left">
                    <LanguageSelect type="B" />
                  </li>
                </ul>
                <header className="nav-header py-2 px-5 text-white d-lg-none">
                  <div className="text-center gap-5">
                    <div className="pb-2 pt-2">
                      <Link to="/admin/dashboard" className="d-md-ms-0  d-ms-4">
                        {t("Menu.home")}
                      </Link>
                    </div>
                    <div className="pb-2">
                      <Link to="/admin/registration">{t("Menu.profile")}</Link>
                    </div>
                    <div className="pb-2">
                      <Link to="#" onClick={() => logout()}>
                        {t("Menu.logout")}
                      </Link>
                    </div>
                    <div className="pb-2">
                      <LanguageSelect type="A" />
                    </div>
                  </div>
                </header>
              </>
            ) : (
              <>
                <ul className="navbar-nav mb-2 mb-lg-0 en-ms-auto ar-me-auto align-items-center">
                  <li className="nav-item me-5 ">
                    <LanguageSelect type="A" />
                  </li>
                  <li className="nav-item me-5">
                    <a
                      href="https://www.facebook.com/PandaSaudi"
                      target="_blank"
                    >
                      <img
                        src="/images/facebook-logo.svg"
                        className="img-fluid"
                        alt={t("Social.facebook")}
                      />
                    </a>
                  </li>
                  <li className="nav-item me-5">
                    <a
                      href="https://www.instagram.com/pandasaudi"
                      target="_blank"
                    >
                      <img
                        src="/images/instragram-logo.svg"
                        className="img-fluid"
                        alt={t("Social.instagram")}
                      />
                    </a>
                  </li>
                  <li className="nav-item me-5">
                    <a
                      href="https://www.youtube.com/channel/UCoq-QkHplVvXm4i4DxPuCHw"
                      target="_blank"
                    >
                      <img
                        src="/images/youtube-logo.svg"
                        className="img-fluid"
                        alt={t("Social.youtube")}
                      />
                    </a>
                  </li>
                  <li className="nav-item me-5">
                    <a href="https://twitter.com/PandaSaudi" target="_blank">
                      <img
                        src="/images/twitter-logo.svg"
                        className="img-fluid"
                        alt={t("Social.twitter")}
                      />
                    </a>
                  </li>
                  <li className="nav-item p-left">
                    <a
                      href="https://www.linkedin.com/company/azizia-panda-united-savola-group/"
                      target="_blank"
                    >
                      <img
                        src="/images/linkedin-logo.svg"
                        className="img-fluid"
                        alt={t("Social.linkedin")}
                      />
                    </a>
                  </li>
                </ul>
                <header className="nav-header py-2 px-5 text-white d-lg-none">
                  <div className="text-center gap-5">
                    <div className="pb-2 pt-2">
                      <a
                        href="https://panda.com.sa/about-us"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("Menu.about_panda")}
                      </a>
                    </div>
                    <div className="pb-2 pt-2">
                      <a
                        href="https://panda.com.sa/#quicklinks"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("Menu.contact")}
                      </a>
                    </div>
                    <div className="pb-2 pt-2">
                      <a
                        href={`https://panda.sa/${i18next.language}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("Menu.shop_with_us")}
                      </a>
                    </div>
                    <div className="pb-2">
                      <LanguageSelect type="A" />
                    </div>
                  </div>
                </header>
              </>
            )}
          </div>
        </div>
      </nav>
      {!(context && context.key && context.key.auth_key) && (
        <header className="common-header py-2 px-5 text-white">
          <div className="d-flex justify-content-center gap-5 text-uppercase">
            <div className="pb-2 pt-2">
              <a
                href="https://panda.com.sa/about-us"
                target="_blank"
                rel="noreferrer"
              >
                {t("Menu.about_panda")}
              </a>
            </div>
            <div className="pb-2 pt-2">
              <a
                href="https://panda.com.sa/#quicklinks"
                target="_blank"
                rel="noreferrer"
              >
                {t("Menu.contact")}
              </a>
            </div>
            <div className="pb-2 pt-2">
              <a
                href={`https://panda.sa/${i18next.language}`}
                target="_blank"
                rel="noreferrer"
              >
                {t("Menu.shop_with_us")}
              </a>
            </div>
          </div>
        </header>
      )}
    </>
  );
};

export default Header;
